// ConfirmDetails.js
import React, { useEffect, useState } from "react";
import { Button, Container, Row, Col } from "react-bootstrap";
import "./ConfirmDetails.css";
import { Calender } from "../../../assets/icons/Calender";
import "bootstrap-icons/font/bootstrap-icons.css";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { SignUpLearnerData } from "../../../redux/slice/authSlice";
import { yupResolver } from "@hookform/resolvers/yup";
import { EyeClosed } from "../../../assets/icons/EyeClosed";
import { EyeShoow } from "../../../assets/icons/EyeShoow";
import { LeftArrow } from "../../../assets/icons/LeftArrow";
import { Link } from "react-router-dom";
import { Routers } from "../../../routes/Constant";
import { useDispatch, useSelector } from "react-redux";
import { objectFiledDataStart } from "../../../redux/slice/objectSlice";
import { loginStart } from "../../../redux/slice/authSlice";
import CofirmDetailLogin from "./CofirmDetailLogin";

function PasswordInput({ label, name, register, errors }) {
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
  

  return (
    <>
      <div className="input_block">
        <div className="position-relative">
          <input
            type={showPassword ? "text" : "password"}
            className="input_tag br-10 p-4"
            {...register(name, { required: true })}
            placeholder={`${label}*`}
          />
          <span className="password-toggle" onClick={togglePasswordVisibility}>
            {showPassword ? <EyeShoow /> : <EyeClosed />}
          </span>
        </div>
        {errors[name] && (
          <div className="text-danger m-1">{errors[name].message}</div>
        )}
      </div>
    </>
  );
}

export const ConfirmDetails = ({
  SelectPacknext,
  updateFieldData,
  bookingData,
}) => {
  const cal = useSelector((state) => state.calender.name);
  const formHandler = (data) => {
    setAccountExit(data)
  }
  const [accountExit,setAccountExit] = useState(true);
  const [pickupLocation, setPickupLocation] = useState(
    bookingData?.pickup_location || ""
  );
  const [city, setCity] = useState(bookingData?.city || "");
  const [postalCode, setPostalCode] = useState(bookingData?.postal_code || "");
  const [error, setError] = useState(false);
  const [token,setToken]=useState(null)
  useEffect(()=>{
    setToken(localStorage.getItem("token"))
    updateFieldData("learner_id", user?.data?.data?.id);
  },[])
  const handleConfirm = () => {
    if (pickupLocation && city && postalCode) {

      SelectPacknext();
      setError(false);
    } else {
      setError(true);
    }
  };

  function formatDate(inputDate) {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(inputDate).toLocaleDateString(
      "en-US",
      options
    );

    return formattedDate;
  }

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [generateDefaultAddress, setGenerateDefaultAddress] = useState(false);
  const { user } = useSelector((state) => state?.auth);
  const schema = yup.object().shape({
    first_name: yup.string().required("First Name  is required"),
    last_name: yup.string().required("Last Name is required"),
    email: yup
      .string()
      .required("Email is required")
      .email("Invalid email format"),
    phone: yup.string().required("Phone number is required"),
    notification_checkbox: "",
    condition_checkbox: yup
      .bool()
      .oneOf([true], "Please accept Terms and Conditions to continue"),
    dob: yup.string().required("Date of Birth is required"),
    street: yup.string().required("Street Address is required"),
    street_number: yup.string().required("Street No. is required"),
    suburb: yup.string().required("Suburb is required"),
    state: yup.string().required("State is required"),
    gender: yup.string().required("Gender is required"),
    password: yup.string().min(6, "Password must contain at least 6 character"),
    post_code: yup.string().required("Postal Code is required"),
    password_confirmation: yup
      .string()
      .min(6, "Password must contain at least 6 character")
      .oneOf([yup.ref("password")], "Password do not match"),
  });

  const {
    register,
    reset,
    handleSubmit,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

const onSubmitdata = (values) => {
  const {
    generateDefaultAddress,
    referal_code,
    heard_about_us,
    ...formData
  } = values;

  if (generateDefaultAddress) {
    formData.address = `${values.street_number} ${values.street}, ${values.suburb}, ${values.post_code}, ${values.state}`;
  } else {
    formData.address = values.address;
  }

  formData.referal_code = referal_code || "";
  formData.heard_about_us = heard_about_us || "";

  // ✅ Add your custom field
  formData.status = "active";

  dispatch(SignUpLearnerData(formData));
  reset();

  setTimeout(() => {
    setAccountExit(false);
  }, 5000);
};


  const { instructors } = useSelector(
    (state) => state.instructorPostalCodeReducer
  );

  const postCode = instructors?.data?.map((e) => e.pin_code);

  return (
    <section className="confirmDetail_section m-bot">
      <Container>
        <Row>
          <Col className="mt-5">
              <div className="d-flex justify-content-center flex-column form-cd br-10  m-auto">
                <div className="cd_head_bg p-3">
                  <h5 className="text-center progress_head pt-2">
                    CONFIRM DETAILS
                  </h5>
                </div>
                <div className="p-3">
                  <div className="bg-grey rounded-3 mt-3 mb-3 p-3 ">
                    <h6 className="progress_sub_head">
                      Booking with {bookingData.name_instructor}
                    </h6>
                    <ul className="list-unstyled">
                      {bookingData.start_date?.map((i, index) => {
                        return (
                          <li className="calender_time_sec">
                            <span key={index}>
                              <Calender />
                              <span key={index}>{formatDate(i)}</span>
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                
                {!token ? <div className="signup_learner">
                  {accountExit ? 
                  <form onSubmit={handleSubmit(onSubmitdata)}>
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <div className="input_block">
                          <input
                            type="text"
                            className="input_tag br-10 p-4"
                            {...register("first_name", { required: true })}
                            placeholder="First Name*"
                          />
                          {errors.first_name && (
                            <div className="text-danger m-1">
                              {errors.first_name.message}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <div className="input_block">
                          <input
                            type="text"
                            className="input_tag br-10 p-4"
                            {...register("last_name", { required: true })}
                            placeholder="Last Name*"
                          />
                          {errors.last_name && (
                            <div className="text-danger m-1">
                              {errors.last_name.message}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="mb-3">
                      <select
                        className="input_tag form-control select_signup_learner br-10 p-3"
                        name="gender"
                        {...register("gender")}
                      >
                        <option value="" selected disabled>
                          Gender*
                        </option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="other">Other</option>
                      </select>
                      {errors.gender && (
                        <div className="text-danger m-1">
                          {errors.gender.message}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <input
                        type="text"
                        placeholder="Date of Birth*(DD/MM/YYYY)"
                        className="input_tag br-10 p-4"
                        {...register("dob", { required: true })}
                        onFocus={(e) => (e.target.type = "date")}
                        onBlur={(e) => (e.target.type = "text")}
                      />
                      {errors.dob && (
                        <div className="text-danger m-1">
                          {errors.dob.message}
                        </div>
                      )}
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          placeholder="Street No.*"
                          className="input_tag br-10 p-4"
                          {...register("street_number", { required: true })}
                        />
                        {errors.street_number && (
                          <div className="text-danger m-1">
                            {errors.street_number.message}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          placeholder="Street Address*"
                          className="input_tag br-10 p-4"
                          {...register("street", { required: true })}
                        />
                        {errors.street && (
                          <div className="text-danger m-1">
                            {errors.street.message}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          placeholder="Suburb*"
                          className="input_tag br-10 p-4"
                          {...register("suburb", { required: true })}
                        />
                        {errors.suburb && (
                          <div className="text-danger m-1">
                            {errors.suburb.message}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          placeholder="Postal Code*"
                          className="input_tag br-10 p-4"
                          {...register("post_code", { required: true })}
                        />
                        {errors.post_code && (
                          <div className="text-danger m-1">
                            {errors.post_code.message}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mb-3">
                      <select
                        className="input_tag form-control select_signup_learner br-10 p-3"
                        name="state"
                        {...register("state")}
                      >
                        <option value="" selected disabled>
                          State
                        </option>
                        <option value="New South Wales">New South Wales</option>
                        <option value="Australian Capital Territory">
                          Australian Capital Territory
                        </option>
                        <option value="Northern Territory">
                          Northern Territory
                        </option>
                        <option value="Queensland">Queensland</option>
                        <option value="South Australia">South Australia</option>
                        <option value="Tasmania">Tasmania</option>
                        <option value="Victoria">Victoria</option>
                        <option value="Western Australia">
                          Western Australia
                        </option>
                      </select>
                    </div>
                    {errors.state && (
                      <div className="text-danger m-1">
                        {errors.state.message}
                      </div>
                    )}

                    <div className="mb-3">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          {...register("generateDefaultAddress")}
                          id="generate-default-address"
                          onChange={(e) =>
                            setGenerateDefaultAddress(e.target.checked)
                          }
                        />
                        <label
                          htmlFor="generate-default-address"
                          className="form-check-label ms-2"
                        >
                          Default Pickup Address is same as given address
                        </label>
                      </div>
                    </div>

                    {!generateDefaultAddress && (
                      <div className="mb-3">
                        <input
                          type="text"
                          placeholder="Default Pickup Address"
                          className="input_tag br-10 p-4"
                          {...register("address")}
                        />
                        {errors.address && (
                          <div className="text-danger m-1">
                            {errors.address.message}
                          </div>
                        )}
                      </div>
                    )}

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          maxLength="10"
                          placeholder="Phone*"
                          className="input_tag br-10 p-4"
                          {...register("phone", { required: true })}
                        />
                        {errors.phone && (
                          <div className="text-danger m-1">
                            {errors.phone.message}
                          </div>
                        )}
                      </div>
                      <div className="col-md-6 mb-3">
                        <input
                          type="Email"
                          className="input_tag br-10 p-4"
                          {...register("email", { required: true })}
                          placeholder="Email*"
                        />
                        {errors.email && (
                          <div className="text-danger m-1">
                            {errors.email.message}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <PasswordInput
                          label="Password"
                          name="password"
                          register={register}
                          errors={errors}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <PasswordInput
                          label="Confirm Password"
                          name="password_confirmation"
                          register={register}
                          errors={errors}
                        />
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <input
                          type="text"
                          placeholder="Referral From"
                          className="input_tag br-10 p-4"
                          {...register("referal_code")}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <select
                          className="input_tag form-control select_signup_learner br-10 p-3"
                          name="heard_about_us"
                          {...register("heard_about_us")}
                        >
                          <option value="" selected disabled>
                            Referral Source
                          </option>
                          <option value="Friend's">Friend's</option>
                          <option value="Social Media">Social Media</option>
                          <option value="Other">Other</option>
                        </select>
                      </div>
                    </div>

                    <div className="form-check checkbox-xl mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="condition_checkbox"
                        {...register("condition_checkbox", { required: true })}
                        id="checkbox-1"
                      />
                      <label className="form-check-label" htmlFor="checkbox-1">
                        I agree to the{" "}
                        <span className="text-indigo fw-bold">
                          Terms & Conditions*
                        </span>
                      </label>
                    </div>
                    {errors.condition_checkbox && (
                      <div className="text-danger">
                        {errors.condition_checkbox.message}
                      </div>
                    )}

                    <div className="form-check checkbox-xl mt-3">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        name="notification_checkbox"
                        {...register("notification_checkbox")}
                        id="checkbox-2"
                      />
                      <label className="form-check-label" htmlFor="checkbox-2">
                        Receive SMS notifications.
                      </label>
                    </div>

                    <div className="btn-wrapper-confirmDetail">
                        <Button
                          variant="primary"
                          type="submit"
                          className="submit-btn border-0 rounded-2"
                        >
                          Create Account
                        </Button>
                        <Button
                          variant="primary"
                          className="submit-btn border-0 rounded-2"
                          onClick={(e)=>{
                            e.preventDefault();
                            setAccountExit(false);
                          }}
                        >
                          Already have an Account?
                        </Button>
                    </div>
                  </form> :   <CofirmDetailLogin SelectPacknext={SelectPacknext} bookingData={bookingData} updateFieldData={updateFieldData} formHandler={formHandler}/>}
                </div> : <div className="btn-wrapper-confirmDetail"><Button
                          variant="primary"
                          onClick={()=>{SelectPacknext();}}
                          className="submit-btn border-0 rounded-2"
                        >
                          Continue
                        </Button></div>}
                </div>
              </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
